<template>
	<div>
			
			<div class="commonBox">
				<div>
					<div class="aboutInfo">

						<div class="title">
							여러분의 꿈을 최상의 퀄리티로 개발해드립니다.
						</div>

					</div>
				</div>
			</div>
			
			<div class="aboutVisual" v-bind:style="{ backgroundImage: 'url(' + visualBg + ')' }"></div>
			
			<div class="commonBox">
				<div>
					<div class="aboutInfo">

						<div class="about">
							<p>
								당사 홈페이지에 방문해주신 모든 분들께 감사 인사드립니다!<br>
								웹개발사 <b>일삼사삼사공</b>은 2021년에 설립되어<br>
								모든 여러분들의 꿈을 개발해주고자 혜성같이 나타났습니다.
							</p>

							<p>
								<b>일삼사삼사공</b> 상호명과 뜻이 매우 생소하실텐데요,<br>
								해당 상호명은 대표명을 따와서 만들어졌습니다.<br><br>
								대표명의 <b>명왕성</b>은 태양계에서 퇴출되어, 이름을 잃어버리고 코드명으로 불립니다.<br>
								그 코드명이 바로 <b>134340</b>입니다.<br>
								대표명을 앞세워, 상호명에 당당하게 기재해두었습니다.<br>
								그만큼 제 이름을 걸고서 여러분의 꿈을 완벽하게 개발해드릴 자신이 있습니다.
							</p>

							<p>
								행성 <b>134340</b>은 태양계 궤도를 벗어나 태양계에서 퇴출이 되었습니다.<br>
								하지만 당사는 궤도를 벗어난 이유가 다른 이유들이 아닌, 한 곳에 머물지 않고<br>
								새로운 꿈을 찾아 떠나는 것으로 생각하였기에, 저희 일삼사삼사공도 한 곳에 머물지 않는<br>
								늘 새로운 것을 창조하며 여러분의 꿈에 날개를 달아 개발해드릴 것을 다짐합니다.<br>
								비록 지금은 아무것도 아닌 작고 왜소환 행성과 같은 신생기업이지만 가능성과 꿈이 가득하니<br>
								믿고 여러분의 꿈을 맡겨주시면 최선을 다해 날개를 달아 꿈이 아닌<br>
								현실로 만들어 보이겠습니다.
							</p>

							<p>
								당사의 주 개발 언어는
								<span>HTML5</span>
								<span>CSS3</span>
								<span>JQUERY</span>
								<span>PHP</span>
								<span>LINUX</span>
								<span>NODE JS</span>
								<span>VUE</span>
								로써 해당 언어들에 대해서는 조금 더 발전하고,<br>
								늘 새로운 언어를 찾아 속도감 있고, 트렌드적인 결과물을 선보일 것입니다.<br>
								감사합니다!
							</p>
						</div>

					</div>
				</div>
			</div>
		
	</div>
</template>

<style>
	.aboutInfo > .title { width: 100%; float: left; text-align: center; font-weight: 500; font-size: 28px; color: #000; padding-top: 20px; }
	
	.aboutVisual { width: 100%; height: 600px; float: left; background-position: center bottom; background-size: cover; margin: 20px 0; }
	
	.aboutInfo > .about { width: 100%; float: left; }
	.aboutInfo > .about > p { width: 100%; float: left; word-break: keep-all; font-size: 16px; line-height: 28px; margin-bottom: 30px; }
	.aboutInfo > .about > p > span { display: inline-block; background-color: #F6F6F6; border-radius: 5px; padding: 0 15px; margin: 0 5px; font-weight: 500; color: #0000C8; border: 1px solid #0000C8; margin-bottom: 5px; }
	
	@media (max-width: 700px){
		.aboutInfo > .title { font-size: 21px; }
		
		.aboutVisual { height: auto; padding-bottom: 50%; margin-bottom: 0; }
		
		.aboutInfo > .about > p { margin-bottom: 15px; font-size: 13px; line-height: 21px; }
		.aboutInfo > .about > p > span { padding: 0 10px; margin: 0 2px; margin-bottom: 3px; }
	}
</style>

<script>
	var $;
	
	import visual from "@/assets/img/about_visual.jpg";
	
	export default {
		name : "about",
		data : function(){
			return {
				topVisualTitle : "회사소개",
				topVisualSub : "꿈을 개발해드리는 행성, 일삼사삼사공입니다.",
				visualBg : visual,
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.$parent.pageOpen();
				$.$parent.topVisualTitle = $.topVisualTitle;
				$.$parent.topVisualSub = $.topVisualSub;
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/about.vue